<template>
	<div class="ae">
		<div class="bg_box">
			<div class="content_box clear_both">
				<img src="../../../../assets/ae.png" alt="">
				<div class="float_box">
					<div class="title_wrap">
						<h1 class="title"><span> 弱视百科</span></h1>
						<h1 class="en_title">ENCYCLOPEDIAS</h1>
					</div>
					<div class="swiper_box">
						<div class="swiper-container" style="height: 100%;">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<p class="desc">弱视是指视觉发育期内由于异常视觉经验引起的单眼或双眼最佳矫正视力下降，眼部检查无器质性病变。矫正视力非固定值不再将 0.8 作为弱视诊断的唯一标准，需充分考虑到低龄幼儿视力未充分育或发育迟缓等情况的存在，婴幼儿年龄与正常视力下限。它是一种发育性疾病，严重影响视觉功能，患者不仅视力低下，看东西缺乏立体感，而且配镜后无法有效提高视力，还会导致融合消失，成为立体盲。更重要的是，斜弱视治疗存在巨大的时效性，弱视儿童超过12岁，治疗效果会大打折扣，长此以往，也会影响孩子的心理健康。而且将来驾驶、测绘及很多高科技精密工作都不能胜任。</p>
								</div>
								<div class="swiper-slide">
									<p class="desc">国内外的多项研究表明，眼科疾病不仅是眼部器质性的问题，还常常伴随着神经系统尤其是大脑是皮层内的功能障碍，譬如，斜视不仅存在眼外肌肌力不平衡的现象，还常常导致弱视；先天性白内障手术后，依然存在光栅锐度等视觉功能发育滞后的问题。传统的方法无法精确、有效地评估大脑视皮层的功能状态，因而阻碍了相关疾病的病状评定和病因探索，也影响了这些疾病的治疗。科飞皮层性视觉功能检测仪是目前唯一一款可同时应用于基础和临床研究的、评估视皮层功能的检测设备，可帮助临床医师精确地评估患者的皮层功能状况，全面地把握患者的发病状态，深入地探索发病位点，合理地制定治疗方案。此外，科飞皮层性视觉功能检测仪还可无缝衔接科飞视知觉学习治疗软件，使用治疗软件中的十一项视知觉学习任务，对皮层性视觉功能障碍进行个性化的精确治疗。</p>
								</div>
							</div>
						</div>
					</div>
					<div class="swiper_control">
						<i class="prev" @click="handlePrevClick"></i>
						<i class="next" @click="handleNextClick"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.initSwiper();
		},
		methods: {
			/***************** @Events **********************/
			// 点击上一页
			handlePrevClick() {
				this.swiper_instance.slidePrev(300);
			},
			// 点击下一页
			handleNextClick() {
				this.swiper_instance.slideNext(300);
			},
			
			/***************** @Function **********************/
			// 初始化swiper
			initSwiper() {
				this.swiper_instance = new this.Swiper ('.ae .swiper-container', {
					loop: false,
					allowTouchMove: false
				});
			},
		}
	}
</script>

<style scoped>
	.ae{ position: relative;height: 660px;margin-top: 70px; }
	.ae .bg_box{ position: absolute;width: 1920px;height: 660px;top: 0;left: 50%;margin-left: -960px;background-image: url(../../../../assets/technical_support.png);background-size: cover;background-position: center bottom; }
	.ae .content_box{ position: relative;width: 1200px;margin: 0 auto;padding: 68px 0; }
	.ae img{ display: block;float: right; }
	.ae .float_box{ display: block;position: absolute;width: 680px;top: 94px;left: 0;padding: 60px 0 10px 0;border-radius: 5px 0px 0px 5px;background: #ffb805; }
	.ae .title_wrap{ padding: 0 40px; }
	.ae .float_box .title{ position: relative;font-size: 30px;font-weight: bold;line-height: 42px; }
	.ae .float_box .title::before{ content: "";display: block;position: absolute;width: 160px;height: 11px;bottom: 2px;left: 0;background: #2b53c6; }
	.ae .float_box .title span{ display: block;position: relative;z-index: 9;margin-left: 10px; }
	.ae .float_box .en_title{ font-size: 24px;color: #cc960e;line-height: 34px; }
	.ae .swiper_box{ height: 300px;margin-top: 20px;padding: 0 30px; }
	.ae .desc{ height: 100%;padding: 0 10px;font-size: 16px;color: #222223;text-indent: 2em;line-height: 30px;overflow: hidden; }
	.ae .swiper_control{ margin-top: 10px;padding: 0 15px;text-align: right; }
	.ae .swiper_control .prev{ display: inline-block;width: 32px;height: 32px;margin-right: 5px;background-image: url(../../../../assets/prev_block_icon.png);vertical-align: top; }
	.ae .swiper_control .next{ display: inline-block;width: 32px;height: 32px;background-image: url(../../../../assets/next_block_icon.png);vertical-align: top; }
	.ae .swiper_control .prev:hover{ cursor: pointer;background-image: url(../../../../assets/prev_on_block_icon.png); }
	.ae .swiper_control .next:hover{ cursor: pointer;background-image: url(../../../../assets/next_on_block_icon.png); }
</style>
